export const SUCCESS_TIMELINE_STEPS = [
  {
    title: 'Validação da renegociação',
    description: 'A solicitação foi enviada.',
  },
  {
    title: 'Aprovação do contrato',
    description: 'Seu contrato será registrado no sistema oficial do governo (Dataprev e MTE).',
  },
  {
    title: 'Desconto na folha de pagamento',
    description:
      'Sua empresa receberá as informações do novo contrato para realizar o desconto em folha. Caso isso não ocorra, entre em contato com o RH.',
  },
  {
    title: 'Quitação e início das novas parcelas',
    description:
      'O contrato anterior é quitado e as novas parcelas passam a valer conforme a competência da folha de pagamento.',
  },
] as const

export const getPropostasContratosUrl = (isApp: boolean): string =>
  isApp
    ? String(process.env.REACT_APP_HOME_EMPRESTIMO_PROPOSTAS_CONTRATOS)
    : String(process.env.REACT_APP_HOME_EMPRESTIMO_NOVO)
